import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

import LoadingPaper from "../components/LoadingPaper"

export default function EmailConfirmed() {
  const [secondsToRedirect, setSecondsToRedirect] = useState(5)
  const navigate = useNavigate()

  useEffect(() => {
    let intervalID
    if (secondsToRedirect === 0) {
      navigate("/user/log-in")
    } else {
      intervalID = setInterval(() => setSecondsToRedirect((s) => s - 1), 1000)
    }
    return () => {
      clearInterval(intervalID)
    }
  }, [navigate, secondsToRedirect])

  return (
    <>
      <Box sx={{ mt: (theme) => theme.spacing(2) }}>
        <LoadingPaper isLoading>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <MarkEmailReadIcon fontSize="large" color="success" />
          </Box>
          <Typography
            variant="h6"
            textAlign="center"
            sx={{ mt: (theme) => theme.spacing(2) }}
          >
            Email confirmed successfully
          </Typography>
          <Typography variant="body1" sx={{ mt: (theme) => theme.spacing(1) }}>
            Redirecting you to log in after {secondsToRedirect} seconds...
          </Typography>
        </LoadingPaper>
      </Box>
    </>
  )
}
